import { Helmet } from "react-helmet-async";
import { FeaturedCampaigns } from "components/featured-campaigns";
import { RaiseHeroSection } from "components/raise/raise-hero-section";
import { RaiseBenefitsSection } from "components/raise/raise-benefits-section";
import { RaiseHowItWorksSection } from "components/raise/raise-how-it-works-section";
import { RaiseRegisterSection } from "components/raise/raise-register-section";

export default function RaisePage() {
  return (
    <>
      <Helmet>
        <title>List Your Company | Fortify</title>
        <meta
          name="description"
          content="Raise capital for your business through equity crowdfunding on Fortify."
        />
      </Helmet>

      <RaiseHeroSection />
      <RaiseBenefitsSection />
      <RaiseHowItWorksSection />
      <FeaturedCampaigns cardsOnly />
      <RaiseRegisterSection />
    </>
  );
}
